import $ from 'jquery'
import dtNet from 'datatables.net'
import dtNetDt from 'datatables.net-dt'
import dtNetResponsive from 'datatables.net-responsive'

dtNet(window, $)
dtNetDt(window, $)
dtNetResponsive(window, $)

import Rails from '@rails/ujs'

// Expose jQuery globally for non-module scripts
window.jQuery = $
window.$ = $

if (window.newrelic) {
  // NR is added globally by the newrelic_rpm gem
  console.log('NewRelic detected, adding custom attributes')
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const screenResolution = `${screenWidth}x${screenHeight}`

  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight
  const viewportResolution = `${viewportWidth}x${viewportHeight}`

  newrelic.setCustomAttribute('clientId', window.ENV.CLIENT_ID)
  newrelic.setCustomAttribute('clientName', window.ENV.CLIENT_NAME)
  newrelic.setCustomAttribute('userId', window.ENV.USER_ID || null)
  newrelic.setCustomAttribute('userName', window.ENV.USER_NAME || null)
  newrelic.setCustomAttribute('hotjarSessionId', window.ENV.REQUEST_ID)
  newrelic.setCustomAttribute('screenWidth', screenWidth)
  newrelic.setCustomAttribute('screenHeight', screenHeight)
  newrelic.setCustomAttribute('screenResolution', screenResolution)
  newrelic.setCustomAttribute('viewportWidth', viewportWidth)
  newrelic.setCustomAttribute('viewportHeight', viewportHeight)
  newrelic.setCustomAttribute('viewportResolution', viewportResolution)
}

Rails.start()

$(document).ready(function () {
  setTimeout(() => {
    $('.alert').fadeOut()
  }, 4000)

  $('.js-open-modal').on('click', function (e) {
    e.preventDefault()
    var modalId = $(this).data('js-modal')
    $.each($(this).data(), function (i, v) {
      if (i.startsWith('attribute')) {
        var attribute = i.split('attribute')[1]
        $(`#${modalId} input[name="${attribute}"]`).val(v)
      }
    })
    $(`#${modalId}`).addClass('visible')
  })

  $('.js-close-modal').on('click', function (e) {
    e.preventDefault()
    var modalId = $(this).data('js-modal')
    $(`#${modalId}`).removeClass('visible')
  })

  $('form[data-confirm-submit]').on('submit', function (e) {
    e.stopImmediatePropagation()
    if (!confirm($(e.target).data('confirm-submit'))) {
      e.preventDefault()
    }
  })

  $('.js-mobile-menu').on('click', function () {
    $('.mobile-menu-overlay').show().addClass('visible')
  })

  $('.js-close-mobile-menu').on('click', function () {
    $('.mobile-menu-overlay').hide().removeClass('visible')
  })
})

import Table from '../bundles/Shared/components/DataTable/Table'
$(document).ready(function () {
  const node = document.getElementById('datatable-container')
  if (node) {
    const table = node.dataset.table
    ReactDOM.render(<Table table={table} />, node)
  }
})

$(document).ready(function () {
  $('form[data-confirm]').submit(function (e) {
    var $form = $(this)
    var message = $form.data('confirm')
    if (!confirm(message)) {
      e.preventDefault()
    }
  })

  document.querySelector('.sidebar-tab')?.addEventListener('click', function (e) {
    e.preventDefault()
    localStorage.setItem(
      'focus-mode',
      localStorage.getItem('focus-mode') === 'true' ? 'false' : 'true'
    )
    document.body.classList.toggle(
      'focus-mode',
      localStorage.getItem('focus-mode') === 'true'
    )
  })
  document.body.classList.toggle(
    'focus-mode',
    localStorage.getItem('focus-mode') === 'true'
  )
})

import AjaxNumber from '../bundles/Shared/components/AjaxNumber'
bindToDom('AjaxNumber', AjaxNumber)
import Analytics from 'Analytics/components/Analytics'
bindToDom('Analytics', Analytics)
import AudienceActions from '../bundles/AudienceActions/components/AudienceActions.jsx'
bindToDom('AudienceActions', AudienceActions)
import ManageBrandSettings from '../bundles/Settings/ManageBrandSettings/components/ManageBrandSettings'
bindToDom('ManageBrandSettings', ManageBrandSettings)
import BuildSyncedAudience from 'Advertising/components/BuildSyncedAudience'
bindToDom('BuildSyncedAudience', BuildSyncedAudience)
import CampaignActions from 'Campaigns/ManageCampaign/components/Actions.jsx'
bindToDom('CampaignActions', CampaignActions)
import CampaignApproval from 'Campaigns/CampaignApproval/components/CampaignApproval'
bindToDom('CampaignApproval', CampaignApproval)
import CampaignBuilder from 'CampaignBuilder/components/CampaignBuilder'
bindToDom('CampaignBuilder', CampaignBuilder)
import CampaignOverview from '../bundles/CampaignOverview/components/CampaignOverview'
bindToDom('CampaignOverview', CampaignOverview)
import CampaignVolunteer from '../bundles/CampaignVolunteer/components/CampaignVolunteer'
bindToDom('CampaignVolunteer', CampaignVolunteer)
import CampaignsDatatable from 'CampaignsDatatable/components/CampaignsDatatable'
bindToDom('CampaignsDatatable', CampaignsDatatable)
import ClientSwitcher from 'Interface/ClientSwitcher/components/ClientSwitcher'
bindToDom('ClientSwitcher', ClientSwitcher)
import Compliance from 'Compliance/components/Compliance'
bindToDom('Compliance', Compliance)
import CreateCampaign from '../bundles/Campaigns/CreateCampaign/components/CreateCampaign'
bindToDom('CreateCampaign', CreateCampaign)
import CreateDashboardButton from '../bundles/DashboardBuilder/components/CreateDashboardButton'
bindToDom('CreateDashboardButton', CreateDashboardButton)
import Dashboard from '../bundles/Dashboard/components/Dashboard'
bindToDom('Dashboard', Dashboard)
import DashboardOverview from 'DashboardOverview/components/DashboardOverview'
bindToDom('DashboardOverview', DashboardOverview)
import DashboardBuilder from 'DashboardBuilder/components/DashboardBuilder'
bindToDom('DashboardBuilder', DashboardBuilder)
import DashboardUser from 'DashboardUser/components/DashboardUser'
bindToDom('DashboardUser', DashboardUser)
import DashboardPreview from 'DashboardUser/components/DashboardPreview'
bindToDom('DashboardPreview', DashboardPreview)
import DashboardsDatatable from 'DashboardsDatatable/components/DashboardsDatatable'
bindToDom('DashboardsDatatable', DashboardsDatatable)
import FileUploaderWrapper from '../bundles/Shared/components/ImageUploader/FileUploaderWrapper'
bindToDom('FileUploaderWrapper', FileUploaderWrapper)

dtNet(window, $)
dtNetResponsive(window, $)
import DesktopCaller from '../bundles/DesktopCaller/components/DesktopCaller'
bindToDom('DesktopCaller', DesktopCaller)
import DesktopMessager from '../bundles/DesktopMessager/components/DesktopMessager'
bindToDom('DesktopMessager', DesktopMessager)
import EditUser from 'Users/EditUser/components/EditUser'
bindToDom('EditUser', EditUser)
import EditableName from '../bundles/Shared/components/EditableName/EditableName'
bindToDom('EditableName', EditableName)
import Efforts from 'Efforts/components/Efforts'
bindToDom('Efforts', Efforts)
import EmailBuilder from 'EmailBuilder/components/EmailBuilder'
bindToDom('EmailBuilder', EmailBuilder)
import TargetPreferences from 'TargetPreferences/components/TargetPreferences'
bindToDom('TargetPreferences', TargetPreferences)

window.postFeedback = function () {
  axios.post(window.location.href).catch(() => {
    document.write('Sorry something went wrong')
  })
}
import FlowBuilder from 'FlowBuilder/components/FlowBuilder'
bindToDom('FlowBuilder', FlowBuilder)
import FlowsDatatable from 'FlowsDatatable/components/FlowsDatatable'
bindToDom('FlowsDatatable', FlowsDatatable)
import FlowOverview from 'FlowOverview/components/FlowOverview'
bindToDom('FlowOverview', FlowOverview)
import FlowTaker from 'FlowTaker/components/FlowTaker'
bindToDom('FlowTaker', FlowTaker)
import FlowWizard from 'FlowWizard/components/FlowWizard'
bindToDom('FlowWizard', FlowWizard)

import Help from 'Interface/Help/components/Help'
bindToDom('Help', Help)
import Leaderboard from '../bundles/Shared/components/Leaderboard/index'
bindToDom('Leaderboard', Leaderboard)
import ManageActionsWrapped from 'Shared/components/ManageMenu/ManageActionsWrapped'
bindToDom('ManageActions', ManageActionsWrapped)
import ManageBilling from 'ManageBilling/components/ManageBilling'
bindToDom('ManageBilling', ManageBilling)
import ManageCustomFields from 'Settings/ManageCustomFields/components/ManageCustomFields'

bindToDom('ManageCustomFields', ManageCustomFields)
import ManageEmailSenders from 'Settings/ManageEmailSenders/components/ManageEmailSenders'
bindToDom('ManageEmailSenders', ManageEmailSenders)
import ManageEmailTemplates from 'Settings/ManageEmailTemplates/components/ManageEmailTemplates'
bindToDom('ManageEmailTemplates', ManageEmailTemplates)
import ManageFlowTemplates from 'Settings/ManageFlowTemplates/components/ManageFlowTemplates'
bindToDom('ManageFlowTemplates', ManageFlowTemplates)
import ManageGroup from 'Users/ManageGroup/components/ManageGroup'
bindToDom('ManageGroup', ManageGroup)
import ManageLists from 'Settings/ManageLists/ManageLists'

bindToDom('ManageLists', ManageLists)
import ManageRoles from 'Settings/ManageRoles/components/ManageRoles'
bindToDom('ManageRoles', ManageRoles)
import ManageUsers from 'Users/ManageUsers/components/ManageUsers'
bindToDom('ManageUsers', ManageUsers)
import OverviewStats from '../bundles/CampaignStats/components/OverviewStats.jsx'
bindToDom('OverviewStats', OverviewStats)
import QuickSearches from '../bundles/QuickSearches/components/QuickSearches'
import store from 'Shared/store'
import { Provider } from 'react-redux'

const QuickSearchesWithProvider = (props) => (
  <Provider store={store}>
    <QuickSearches {...props} />
  </Provider>
)

bindToDom('QuickSearches', QuickSearchesWithProvider)
import Reporting from 'Reporting/components/Reporting'
bindToDom('Reporting', Reporting)
import RequestSoftLogin from 'RequestSoftLogin/components/RequestSoftLogin'
bindToDom('RequestSoftLogin', RequestSoftLogin)
import RoleSwitcher from 'Interface/RoleSwitcher/components/RoleSwitcher'
bindToDom('RoleSwitcher', RoleSwitcher)
import SearchBuilder from 'SearchBuilder/components/SearchBuilder'
bindToDom('SearchBuilder', SearchBuilder)
import { Rules } from 'SearchBuilder/components/Description/Rules'
bindToDom('SearchDescription', Rules)
import Search from 'Searches/components/Search.jsx'
bindToDom('Search', Search)
import SendProgress from '../bundles/SendBlast/components/SendProgress'
bindToDom('SendProgress', SendProgress)
import SendBlast from 'SendBlast/components/SendBlast'
bindToDom('SendBlast', SendBlast)
import Spotlight from 'Interface/Spotlight/components/Spotlight'
bindToDom('Spotlight', Spotlight)

import SurveyBuilder from 'SurveyBuilder/components/SurveyBuilder'
bindToDom('SurveyBuilder', SurveyBuilder)
import SurveyOverview from '../bundles/SurveyOverview/components/SurveyOverview.jsx'
bindToDom('SurveyOverview', SurveyOverview)
import Survey from '../bundles/Survey/components/Survey'
bindToDom('Survey', Survey)
import SyncedAudienceShow from 'Advertising/components/SyncedAudienceShow'
bindToDom('SyncedAudienceShow', SyncedAudienceShow)
bindToDom('Table', Table, false)
import TargetDetailsUpdate from 'TargetDetailsUpdate/components/TargetDetailsUpdate'
bindToDom('TargetDetailsUpdate', TargetDetailsUpdate)
import TargetDetailsUpdatesActions from '../bundles/TargetDetailsUpdatesActions/components/TargetDetailsUpdatesActions.jsx'
bindToDom('TargetDetailsUpdatesActions', TargetDetailsUpdatesActions)
import TargetProfile from 'TargetProfile'
bindToDom('TargetProfile', TargetProfile)

import Tutorial from 'Interface/Tutorial/components/Tutorial'
bindToDom('Tutorial', Tutorial)
// Modified from https://codepen.io/claudiabdm/pen/XWgrqGr

import UploadAudience from '../bundles/UploadAudience/components/UploadAudience.jsx'
bindToDom('UploadAudience', UploadAudience)
import UserInfo from 'Interface/UserInfo/components/UserInfo'

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('user-info')

  if (node) {
    const initial = node.getAttribute('data-initial')
    const name = node.getAttribute('data-name')
    const organisation = node.getAttribute('data-organisation')
    const logoutLink = node.getAttribute('data-logout-link')
    const profilePicUrl = node.getAttribute('data-profile-pic-url')

    ReactDOM.render(
      <UserInfo
        initial={initial}
        name={name}
        organisation={organisation}
        logoutLink={logoutLink}
        profilePicUrl={profilePicUrl}
      />,
      node
    )
  }
})
import Actions from '../bundles/Users/Actions/components'
bindToDom('UsersActions', Actions)
import VerifyTwoFactor from 'VerifyTwoFactor/components/VerifyTwoFactor'
bindToDom('VerifyTwoFactor', VerifyTwoFactor)
import WorkflowBuilder from 'Workflows/components/WorkflowBuilder'
bindToDom('WorkflowBuilder', WorkflowBuilder)
import WorkflowsDatatable from 'WorkflowsDatatable/components/WorkflowsDatatable'
bindToDom('WorkflowsDatatable', WorkflowsDatatable)
import WorkflowOverview from 'Workflows/components/WorkflowOverview'
bindToDom('WorkflowOverview', WorkflowOverview)
